var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"rules":_vm.allRules,"counter":_vm.counterNumber,"label":_vm.label || _vm.$t('telephone_number'),"hint":_vm.msisdn},model:{value:(_vm.telephone),callback:function ($$v) {_vm.telephone=$$v},expression:"telephone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }